import type { SearchModalItem, SearchModalSection } from '../search-modal.interface'

export type FlatSearchRow = {
  item: SearchModalItem
  sectionId: string
  flatIndex: number
}

export function flattenSearchSections(sections: SearchModalSection[]): FlatSearchRow[] {
  let flatIndex = 0
  const rows: FlatSearchRow[] = []
  for (const section of sections) {
    for (const item of section.items) {
      rows.push({ item, sectionId: section.id, flatIndex })
      flatIndex += 1
    }
  }
  return rows
}
